import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";

export const PageContainer = styled(PageWrapper)`
  height: 100vh;
  &.entry-app-content {
    .content-holder {
      height: 95vh;
      padding: 0 20px;
      padding-top: 20px;
    }

    .page-content {
      padding-top: 0;
      padding-right: 0;
      padding-left: 0;

      .table-content {
        border-radius: 15px 15px 0px 0px;
        thead th:first-child,
        thead th:last-child {
          border-radius: 0;
        }
      }

      .loader {
        display: flex;
        justify-content: center;
        margin-top: 50px;
      }
    }
  }

  @media (min-width: 1260px) {
    &.entry-app-content {
      padding-top: 0px;
      position: relative;
      padding-right: 0;
    }
  }
`;

export const PageContent = styled.div`
  height: 100%;
  width: 50%;
  margin: 40px auto;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  overflow: hidden;

  box-sizing: border-box;
  height: 100%;

  .chat-container {
    overflow: auto;
    height: calc(100% - 100px);
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;

    &.scroll-purple::-webkit-scrollbar {
      background-color: transparent;
      border-radius: 32px;
      border: 1px solid transparent;
      transition: all 300ms ease-in-out;
      width: 10px;
    }

    &.scroll-purple::-webkit-scrollbar-thumb {
      background-color: rgba(87, 37, 128, 0.25);
      border-radius: 32px;
    }

    .message {
      color: #444;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 18px;
      border-top-right-radius: 18px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      padding: 10px 18px;
      border-radius: 18px;
      word-wrap: break-word;
      white-space: pre-wrap;
      font-size: 13px;
    }

    .chat-bot {
      display: flex;
      margin-bottom: 18px;
      align-items: flex-end;
      justify-content: flex-start;
      gap: 8px;
      width: 100%;

      .message-wrapper {
        max-width: 85%;
      }

      .message {
        background-color: #f5f7fa;
        margin-right: auto;
      }

      .feedback-area {
        margin-top: 8px;
      }

      .feedback-actions {
        display: flex;
        gap: 8px;
      }

      .feedback-btn {
        width: 32px;
        height: 32px;
        border: 1px solid #d9dde3;
        border-radius: 20px;
        background: #fff;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #5f6673;

        &:hover {
          background: #f1f5f9;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        &.active-good {
          background: #1a7f37;
          border-color: #1a7f37;
          color: #fff;
        }

        &.active-bad {
          background: #cf222e;
          border-color: #cf222e;
          color: #fff;
        }
      }

      .feedback-reason {
        margin-top: 8px;

        textarea {
          width: 100%;
          border: 1px solid #d9dde3;
          border-radius: 10px;
          padding: 8px;
          font-size: 13px;
          resize: vertical;
          min-height: 70px;
          font-family: inherit;
        }
      }

      .feedback-reason-actions {
        display: flex;
        gap: 8px;
        margin-top: 8px;

        button {
          border-radius: 18px;
          border: 1px solid var(--color-purple);
          background: #fff;
          color: var(--color-purple);
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;

          &.save {
            background: var(--color-purple);
            color: #fff;
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }

      .feedback-error {
        color: #cf222e;
        font-size: 12px;
        margin-top: 6px;
      }

      .feedback-status {
        color: #1a7f37;
        font-size: 12px;
        font-weight: 600;
        margin-top: 6px;
      }
    }

    .chat-user {
      display: flex;
      margin-bottom: 18px;
      align-items: flex-end;
      gap: 8px;
      width: 100%;

      .message-wrapper {
        margin-left: auto;
        max-width: 85%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .message {
        background-color: var(--color-purple);
        color: white;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 18px;
        border-top-left-radius: 18px;
      }
    }
  }

  .ask-box {
    margin-top: auto;

    padding: 15px 20px;
    background-color: white;
    display: flex;
    align-items: center;
    border-top: 1px solid #e0e0e0;

    input {
      flex: 1;
      padding: 12px 15px;
      border: 1px solid #e0e0e0;
      border-radius: 25px;
      font-size: 16px;
      outline: none;

      &::placeholder {
        color: lightgray;
        font-size: 14px;
      }
    }

    button {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
      padding: 0;
    }
  }
`;

export const Loading = styled.div`
  bottom: 10px;
  margin-top: auto;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  padding: 15px 20px;
  width: 120px;
  gap: 8px;
  border-radius: 16px;
  left: 20px;
  font-size: 14px;

  .typing-indicator {
    display: flex;
    align-items: center;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    background: #f5f7fa;
    color: #666;

    .typing-dots {
      display: flex;
      gap: 4px;
      align-items: center;
      min-width: 28px;
    }

    .typing-dots span {
      width: 8px;
      height: 8px;
      background: #f7931f;
      border-radius: 50%;
      display: inline-block;
      animation: typing 1.4s infinite ease-in-out both;
    }

    .typing-dots span:nth-child(1) {
      animation-delay: 0s;
    }

    .typing-dots span:nth-child(2) {
      animation-delay: 0.2s;
    }

    .typing-dots span:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  @keyframes typing {
    0%,
    60%,
    100% {
      transform: translateY(0);
      opacity: 0.7;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

export const FeedbackBlockMessage = styled.p`
  margin: 8px 20px 0;
  color: #9a6700;
  font-size: 12px;
`;
